import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/api';
import CompanyHeader from '../docs/company_header';
import Drawing from '../drawing';
import DrawTopView from '../draw_top_view';
import DrawScreen from '../DrawScreen';
import Watermark from '../components/Watermark';

const Order = ({ quoteId, showLinePrices = true }) => {
  const [orderRecord, setOrderRecord] = useState();
  const [customerInfo,   setCustomerInfo]  = useState();
  const [orderData,   setOrderData]   = useState([]);

useEffect(() => {
  if (quoteId) {
    //alert(quoteId)
    getOrderRecord(quoteId);
    getOrderData(quoteId);
  }
}, [quoteId]);

useEffect(() => {
  if (orderRecord?.fkCustomerId) {
    getCustomerInfo(orderRecord.fkCustomerId);
  }
}, [orderRecord]);

  const getOrderData = async (quoteId) => {
    try {
      const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
      setOrderData(data);
    } catch (err) {
      console.error('Failed to fetch item quotes:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  const getOrderRecord = async (quoteId) => {
    try {
      const data = await authFetch(`/quotes/${quoteId}`);
      setOrderRecord(data);
    } catch (err) {
      console.error('Failed to fetch quote record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
    const getCustomerInfo = async (customerId) => {
    try {
      const data = await authFetch(`/customers/${customerId}`);
      setCustomerInfo(data);
    } catch (err) {
      console.error('Failed to fetch customer record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  // Calculate grand totals
  const totals = orderData.reduce(
    (acc, item) => {
      const subtotal = parseFloat(item?.doorData?.calc?.subtotal || 0);
      const tax = parseFloat(item?.doorData?.calc?.tax || 0);
      const total = parseFloat(item?.doorData?.calc?.total || 0);

      acc.subtotal += subtotal;
      acc.tax += tax;
      acc.total += total;

      return acc;
    },
    { subtotal: 0, tax: 0, total: 0 }
  );

  const customerBoxStyle = {
        border: '1px solid #ccc',
        borderRadius: '15px', // 👈 oval corners
        padding: '1em',
        maxWidth: '300px',
        backgroundColor: '#f9f9f9',
        margin: '1em 0'
};


return (
  <div className="pdf-capture" style={{ maxWidth: '1500px', margin: '0 auto', textAlign: 'left' }}>
    <CompanyHeader
      documentType="Order"
      quoteData={orderData[0]?.doorData?.document}
      companyName="Eticom"
    />

    {customerInfo && (
      <div style={customerBoxStyle}>
        <p><strong>Issued To:</strong> {customerInfo?.fullName}</p>
        <p>
          {customerInfo?.address1}, {customerInfo?.city}, {customerInfo?.postalCode}, {customerInfo?.province}
        </p>
        <p>{customerInfo?.mobilePhone}</p>
        <p>{customerInfo?.email}</p>
      </div>
    )}
    <Watermark show={true} horizontalOffset={500} />
    <p><strong>Quote ID:</strong> {quoteId}</p>

    <div>
      {orderData.map((item, index) => {
        //if (index === 0) return null; // Skip the first item
        const calc = item?.doorData?.calc || {};
        const frameData = item?.doorData?.frameData || {};
        const visibleLines = calc.visibleLines || [];
        const doorDataCopy2 = { ...item?.doorData };

        return (
          <div
            key={`drawing-container-${item.id}`}
            style={{
              marginBottom: '2em',
              padding: '1em',
              border: '1px solid #ddd',
              borderRadius: '12px',
              background: '#fdfdfd',
            }}
          >
            {/* Flex container: Left = Drawing, Right = Details */}
            <div style={{ display: 'flex', gap: '2em', alignItems: 'flex-start' }}>
              {/* LEFT SIDE */}
              <div style={{ flex: '0 0 auto' }}>
                {item?.itemType !== 'pleatedscreen' && (
                  <>  
                    <Drawing
                      key={`drawing-${item.id}-${index}`} // Force React to remount
                      doorData={item?.doorData}
                      selectedDoor={frameData?.selectedDoor}
                      frameColor={frameData?.frameColor}
                      frameWidth={frameData?.frameWidth}
                      frameHeight={frameData?.frameHeight}
                      sideLiteSize={frameData?.sideLiteSize}
                      overallHeight={frameData?.overallHeight}
                      hinges={frameData?.hinges}
                      transom={{
                        transom: { value: item?.doorData?.transomData?.transom },
                        overallHeight: { value: item?.doorData?.transomData?.OverallHeight },
                      }}
                      swing={frameData?.swing}
                      doorLite={{
                        glassDividers: { value: item?.doorData?.doorLite?.glassDividers },
                        glassDividersVertical: { value: item?.doorData?.doorLite?.glassDividersVertical },
                        glassDividersHorizontal: { value: item?.doorData?.doorLite?.glassDividersHorizontal },
                        exteriorFinish: { value: item?.doorData?.doorLite?.exteriorFinish },
                        interiorFinish: { value: item?.doorData?.doorLite?.interiorFinish },
                      }}
                    />                    
                    <DrawTopView doorData={doorDataCopy2} />
                  </>
                )}
                {item?.itemType === 'pleatedscreen' && <DrawScreen doorData={doorDataCopy2} />}
              </div>

              {/* RIGHT SIDE */}
              <div style={{ flex: 1 }}>
                {/* Detail Lines */}
                {visibleLines.map(([key, line], i) =>
                  line?.isVisible ? (
                    <div key={`${item.id}-line-${i}`} style={{ padding: '4px 0' }}>
                      <span dangerouslySetInnerHTML={{ __html: line.html }} />
                      {item?.doorData?.displayPrices !== false &&
                        line?.price?.isVisible &&
                        line?.price?.price != null &&
                        showLinePrices === true && (
                          <span style={{ float: 'right' }}>
                            ${parseFloat(line.price.price).toFixed(2)}
                          </span>
                        )}
                    </div>
                  ) : null
                )}

                {/* Per-item Totals */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    marginTop: '1em',
                    paddingTop: '0.5em',
                    borderTop: '1px solid #ccc',
                    width: '100%',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                    <span>Quantity:</span>
                    <span style={{ fontWeight: 'bold' }}>{frameData.quantity || 0}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                    <span>Subtotal:</span>
                    <span style={{ fontWeight: 'bold' }}>
                      ${parseFloat(calc.subtotal || 0).toFixed(2)}
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                    <span>Tax:</span>
                    <span style={{ fontWeight: 'bold' }}>
                      ${parseFloat(calc.tax || 0).toFixed(2)}
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '300px' }}>
                    <span>Total:</span>
                    <span style={{ fontWeight: 'bold' }}>
                      ${parseFloat(calc.total || 0).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

};

// Simple inline styles
const thStyle = {
  borderBottom: '2px solid #ccc',
  textAlign: 'left',
  padding: '8px',
  backgroundColor: '#f0f0f0'
};

const tdStyle = {
  borderBottom: '1px solid #eee',
  textAlign: 'left',
  padding: '8px'
};

export default Order;
